import { render } from "./xxqk.vue?vue&type=template&id=4c51fba9&scoped=true&ts=true"
import script from "./xxqk.vue?vue&type=script&lang=ts"
export * from "./xxqk.vue?vue&type=script&lang=ts"

import "./xxqk.vue?vue&type=style&index=0&id=4c51fba9&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c51fba9"]])

export default __exports__